<template>
  <div class="button-top">
    <button class="mr20 btn-db" @click="showFilterModal(content)">Filter</button>
    <button class="mr20 btn-db">Export to Excel</button>
    <!-- Legal Doc -->
    <div v-if="content === 'kbli'">
      <KBLI v-if="showModal" @closeModal="closeModal"/>
    </div>
    <div v-else-if="content === 'dkbli'">
      <DKBLI v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'iujp'">
      <IUJP v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'sbujk'">
      <SBUJK v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'iujptl'">
      <IUJPTL v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'inu_bbm'">
      <INUBBM v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'siupal'">
      <SIUPAL v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'negara'">
      <Negara v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'provinsi'">
      <Provinsi v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'kota'">
      <Kota v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'kecamatan'">
      <Kecamatan v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'kelurahan'">
      <Kelurahan v-if="showModal" @closeModal="closeModal" />
    </div>
    <!-- Tiket Vendor -->
    <div v-else-if="content === 'kategori'">
      <Kategori v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'tujuan_pendaftaran'">
      <TujuanPendaftaran v-if="showModal" @closeModal="closeModal" />
    </div>
    <!-- SAP -->
    <div v-else-if="content === 'bisnis_unit'">
      <BisnisUnit v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'bce'">
      <BCE v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'gems'">
      <GEMS v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'bkes'">
      <BKES v-if="showModal" @closeModal="closeModal" />
    </div>
    <!-- K3L -->
    <div v-else-if="content === 'non_inti'">
      <NonInti v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'golden_rules'">
      <GoldenRules v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'kbub'">
      <KBUB v-if="showModal" @closeModal="closeModal" />
    </div>
    <!-- KPLH -->
    <div v-else-if="content === 'kbug'">
      <KBUG v-if="showModal" @closeModal="closeModal" />
    </div>
    <div v-else-if="content === 'signature_company'">
      <SignatureCompany v-if="showModal" @closeModal="closeModal" />
    </div>
  </div>
</template>


<script>
  export default {

    props: {
      'content': String,
      'tableData': Array,
    },

    components: {
      // Legal Doc
      KBLI: () => import('@/views/MasterData/Filter/LegalDoc/KBLI.vue'),
      DKBLI: () => import('@/views/MasterData/Filter/LegalDoc/DKBLI.vue'),
      IUJP: () => import('@/views/MasterData/Filter/LegalDoc/IUJP.vue'),
      SBUJK: () => import('@/views/MasterData/Filter/LegalDoc/SBUJK.vue'),
      IUJPTL: () => import('@/views/MasterData/Filter/LegalDoc/IUJPTL.vue'),
      INUBBM: () => import('@/views/MasterData/Filter/LegalDoc/INUBBM.vue'),
      SIUPAL: () => import('@/views/MasterData/Filter/LegalDoc/SIUPAL.vue'),
      Negara: () => import('@/views/MasterData/Filter/LegalDoc/Negara.vue'),
      Provinsi: () => import('@/views/MasterData/Filter/LegalDoc/Provinsi.vue'),
      Kota: () => import('@/views/MasterData/Filter/LegalDoc/Kota.vue'),
      Kecamatan: () => import('@/views/MasterData/Filter/LegalDoc/Kecamatan.vue'),
      Kelurahan: () => import('@/views/MasterData/Filter/LegalDoc/Kelurahan.vue'),

      // Tiket Vendor
      Kategori: () => import('@/views/MasterData/Filter/TiketVendor/Kategori.vue'),
      TujuanPendaftaran: () => import('@/views/MasterData/Filter/TiketVendor/TujuanPendaftaran.vue'),

      // SAP
      BisnisUnit: () => import('@/views/MasterData/Filter/SAP/BisnisUnit.vue'),
      BCE: () => import('@/views/MasterData/Filter/SAP/BCE.vue'),
      GEMS: () => import('@/views/MasterData/Filter/SAP/GEMS.vue'),
      BKES: () => import('@/views/MasterData/Filter/SAP/BKES.vue'),
      
      // K3L
      NonInti: () => import('@/views/MasterData/Filter/K3L/NonInti.vue'),
      GoldenRules: () => import('@/views/MasterData/Filter/K3L/GoldenRules.vue'),
      KBUB: () => import('@/views/MasterData/Filter/K3L/KBUB.vue'),
      
      // KPLH
      KBUG: () => import('@/views/MasterData/Filter/KPLH/KBUG.vue'),
      SignatureCompany: () => import('@/views/MasterData/Filter/KPLH/SignatureCompany.vue'),
      
    },

    data() {
      return {
        showModal: false,
      };
    },

    methods: {
      showFilterModal(content) {
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
      },
    }
  }
</script>